var _circle, _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#313D53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7546 11.7746C18.7874 10.8497 17.5571 10.3788 16.1867 10.3788C13.7558 10.3788 11.6983 12.0206 10.9643 14.2267C10.7776 14.7867 10.6716 15.3849 10.6716 16.0001C10.6716 16.6152 10.7776 17.2134 10.9643 17.7733C11.6982 19.9794 13.7558 21.6212 16.1867 21.6212C17.4425 21.6212 18.5116 21.2903 19.3474 20.7303C20.3358 20.0685 20.9934 19.08 21.2098 17.9134H16.1867V14.3031H24.9771C25.0874 14.914 25.1468 15.5504 25.1468 16.2122C25.1468 19.0546 24.1286 21.4473 22.3637 23.0722C20.8195 24.4976 18.7067 25.3334 16.1867 25.3334C12.5383 25.3334 9.38191 23.2419 7.84614 20.1916C7.21402 18.9316 6.85339 17.5061 6.85339 16.0001C6.85339 14.494 7.214 13.0685 7.84612 11.8085C9.38188 8.75822 12.5383 6.66669 16.1867 6.66669C18.7025 6.66669 20.8152 7.59154 22.4316 9.0976L19.7546 11.7746Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#CAF3E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5068 9.44708C52.8121 9.72697 52.8328 10.2014 52.5529 10.5067L41.5529 22.5067C41.4146 22.6575 41.2208 22.7453 41.0163 22.7498C40.8118 22.7542 40.6143 22.6749 40.4697 22.5303L35.4697 17.5303C35.1768 17.2374 35.1768 16.7625 35.4697 16.4696C35.7626 16.1767 36.2374 16.1767 36.5303 16.4696L40.9764 20.9157L51.4471 9.49315C51.727 9.18781 52.2015 9.16718 52.5068 9.44708Z",
    fill: "#3CA377"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGoogle);
export default __webpack_public_path__ + "static/media/successGoogle.c82f45869de4d8c68cfbb6f9cfcb6cab.svg";
export { ForwardRef as ReactComponent };